<template>
    <span>
        <template v-if="fee.strategyTypeId==STRATEGY_TYPES.FIXED_FEE">
            <span v-fee-formula="{formula:fee.formula, amount:100}"></span>
        </template>
        <template v-else-if="fee.strategyTypeId==STRATEGY_TYPES.PERCENTAGE">
            <span v-fee-formula="{formula:fee.formula, amount:100}"></span> for every $100
        </template>
        <template v-else>
            Custom
        </template>
    </span>
</template>

<script>
    import {common} from "../../../global/common.js";

    export default {
        name: "FeeFormula",
        props: {fee: {type: [Object], required: true}},
        data() {
            return {
                STRATEGY_TYPES: common.PAYMENT_STRATEGY_TYPES
            }
        },
    }
</script>

<style scoped>

</style>